export const searchResultMock = [
  {
    'id': 'B0FFG7OAGY',
    'name': '西溪八方城',
    'type': '商务住宅;住宅区;住宅小区',
    'location': {
      lng: 120.046083,
      lat: 30.289958
    },
    'lng': 120.046083,
    'lat': 30.289958,
    'address': '文一西路荆长路以东200米',
    'tel': '0571-85856300',
    'distance': null,
    'shopinfo': '0'
  },
  {
    'id': 'BV11113017',
    'name': '西溪八方城(公交站)',
    'type': '交通设施服务;公交车站;公交车站相关',
    'location': {
      lng: 120.045217,
      lat: 30.288524
    },
    'lng': 120.045217,
    'lat': 30.288524,
    'address': '1301M路社区接驳巴士;2401M路高峰',
    'tel': '',
    'distance': null,
    'shopinfo': '2'
  },
  {
    'id': 'B0FFM9LWLX',
    'name': '瑞幸咖啡(西溪八方城店)',
    'type': '餐饮服务;咖啡厅;咖啡厅',
    'location': {
      lng: 120.045277,
      lat: 30.290888
    },
    'lng': 120.045277,
    'lat': 30.290888,
    'address': '五常街道西溪八方城11幢117',
    'tel': '13456725354',
    'distance': null,
    'shopinfo': '1'
  },
  {
    'id': 'B0GK1R1Z51',
    'name': '麦当劳(杭州西溪八方城)',
    'type': '餐饮服务;快餐厅;快餐厅',
    'location': {
      lng: 120.044961,
      lat: 30.289937
    },
    'lng': 120.044961,
    'lat': 30.289937,
    'address': '五常街道红旗路西溪八方城9幢',
    'tel': '0571-86791709;4008517517',
    'distance': null,
    'shopinfo': '0'
  },
  {
    'id': 'B0IDCUAJVM',
    'name': '中国移动(西溪八方城营业厅)',
    'type': '生活服务;电讯营业厅;中国移动营业厅',
    'location': {
      lng: 120.044602,
      lat: 30.290042
    },
    'lng': 120.044602,
    'lat': 30.290042,
    'address': '西溪八方城9幢122-1号、124-1号',
    'tel': '',
    'distance': null,
    'shopinfo': '0'
  },
  {
    'id': 'B0HK07FX9L',
    'name': '八角杯咖啡(西溪八方城店)',
    'type': '餐饮服务;咖啡厅;咖啡厅',
    'location': {
      lng: 120.04521,
      lat: 30.288855
    },
    'lng': 120.04521,
    'lat': 30.288855,
    'address': '文一西路西溪八方城7栋134',
    'tel': '0571-87113109',
    'distance': null,
    'shopinfo': '0'
  },
  {
    'id': 'BV11222251',
    'name': '西溪八方城西(公交站)',
    'type': '交通设施服务;公交车站;公交车站相关',
    'location': {
      lng: 120.044694,
      lat: 30.289045
    },
    'lng': 120.044694,
    'lat': 30.289045,
    'address': '1301M路社区接驳巴士',
    'tel': '',
    'distance': null,
    'shopinfo': '2'
  },
  {
    'id': 'B0FFJ6L1LB',
    'name': '萌派宠物生活馆(西溪八方城店)',
    'type': '购物服务;专卖店;宠物用品店',
    'location': {
      lng: 120.047111,
      lat: 30.289065
    },
    'lng': 120.047111,
    'lat': 30.289065,
    'address': '西溪八方城5幢105号',
    'tel': '13735430027',
    'distance': null,
    'shopinfo': '0'
  },
  {
    'id': 'B0IASZIOU7',
    'name': '胖虎宠物(西溪八方城店)',
    'type': '购物服务;购物相关场所;购物相关场所',
    'location': {
      lng: 120.046081,
      lat: 30.289124
    },
    'lng': 120.046081,
    'lat': 30.289124,
    'address': '文一西路西溪八方城6栋119',
    'tel': '18698581267',
    'distance': null,
    'shopinfo': '1'
  },
  {
    'id': 'B0JDZZCCOX',
    'name': '顺时茶社(西溪八方城店)',
    'type': '餐饮服务;茶艺馆;茶艺馆',
    'location': {
      lng: 120.046505,
      lat: 30.289279
    },
    'lng': 120.046505,
    'lat': 30.289279,
    'address': '西溪八方城5幢128室',
    'tel': '15306583327',
    'distance': null,
    'shopinfo': '1'
  }
];
